import { CloseThickIcon } from './CloseThickIcon';

/**
 * author: Austin Andrews
 * id C6B8442F-446D-4690-866F-AF0F27C1EAB2
 * name close-thick
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/close-thick.svg
 * tags
 */
export const CancelBoldIcon = CloseThickIcon;
export default CancelBoldIcon